import { z } from "zod"
import { emailSchema } from "../../common/email-validator"
import { MessageType } from "../MessageType"

export const SendEmailAsStoreStaffSchema = z.object({
  jobId: z.string().uuid(),
  content: z.string().min(1),
  toEmail: emailSchema(),
  type: z.nativeEnum(MessageType),
  subject: z.string().min(1).optional(),
  // attachedFiles handled by multer, not in validation
})

export type SendEmailAsStoreStaff = z.infer<
  typeof SendEmailAsStoreStaffSchema
> & {
  attachedFiles?: File[]
}
